module.exports = __webpack_public_path__ + "static/media/Avatar_3.db531097.svg";